import { FormikMultiUserPicker } from 'components/PersonPicker'
import { Field } from 'formik'
import { FormikTextField } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { DepartmentInsertInput } from 'gql.generated'
import { Label, Stack } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export type DepartmentFormValues = DepartmentInsertInput
export const DepartmentForm: React.FC = () => {
  const { t } = useTranslation()

  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name="department"
          component={FormikTextField}
          label={t('Abteilung')}
        />
        <Stack.Item className="composite-field">
          <Label>{t('Abteilungsleiter')}</Label>
          <Field name="headOfDepartment" component={FormikMultiUserPicker} />
        </Stack.Item>
      </FieldStack>
    </FormStack>
  )
}
